/* eslint-disable no-use-before-define */
import { Map, Set } from 'immutable';
import get from 'lodash/get';

import { ApiActions } from '../../constants/ApiActions';
import { createReducer } from '../../lib/ReducerUtils';

const INITIAL_STATE = Map({});

// ALBUM ENTITY REDUCER
export default createReducer(INITIAL_STATE, {
  [ApiActions.FETCH_ALBUM_SUCCESS]: saveAlbumData,
  [ApiActions.FETCH_ARTIST_SUCCESS]: saveAlbumData,
  [ApiActions.FETCH_COMPOSER_SUCCESS]: saveAlbumData,
});

// CASE FUNCTIONS
function saveAlbumData(state, action) {
  const newState = state.mergeDeep(action.response.entities.albums);
  if (action.type === ApiActions.FETCH_ALBUM_SUCCESS) {
    // There are occasional circumstances where the seoToken used to request the album object
    // doesn't match the seoToken in the album object returned from the api. We need to
    // be able to look up the album in the entities collection by either seo token.
    const seoToken = get(action, 'params.content.token');
    const musicId = action.response.result;
    if (seoToken && newState.has(musicId)) {
      let seoTokens = newState.getIn([musicId, 'otherAlbumSeoTokens']) || Set();
      seoTokens = seoTokens.add(seoToken);
      return newState.setIn([musicId, 'otherAlbumSeoTokens'], seoTokens);
    }
  }
  return newState;
}
